"use client"

import { Component } from "react"
import moment from "moment"
import routes from "../../routes/URL"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import Header from "../../components/Header"
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import Toast from "../../components/Toast"

class ListMenuScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      suppliers: [],
      rawMaterial: [],
      showOtherSupplier: false,
      currentSupplier: null,
      currentInvoiceFile: null,
      selectedSupplierId: "",
      selectedPaymentStatus: "",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  async componentDidMount() {
    await this.getSuppliers()
    this.getInventoryInvoiceDetails()
  }

  getInventoryInvoiceDetails = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getInventoryInvoiceDetails(this.props.match.params.id),
    )

    if (status == "success") {
      const {
        items,
        inventory_supplier_id,
        invoice_number,
        invoice_date,
        invoice_amount,
        delivery_charge,
        payment_status,
        gst,
        supplier,
        invoice_file,
      } = data

      // Set form values using DOM for text inputs
      document.getElementById("invoice_number").value = invoice_number
      document.getElementById("invoice_date").value = moment(invoice_date, "DD-MM-YYYY").format("YYYY-MM-DD")
      document.getElementById("invoice_amount").value = invoice_amount
      document.getElementById("delivery_charge").value = delivery_charge
      document.getElementById("gst_amount").value = gst

      // Set state for controlled components
      this.setState({
        selectedSupplierId: inventory_supplier_id,
        selectedPaymentStatus: payment_status == "paid" ? "1" : "2",
        currentSupplier: supplier,
        currentInvoiceFile: invoice_file,
      })

      const toArray = items.map((item) => {
        return [
          item.item_name,
          item.item_quantity,
          item.item_unit,
          item.item_price,
          item.item_total_price,
          item.item_gst,
          item.item_total_with_gst,
        ]
      })

      this.setState({
        rawMaterial: toArray,
      })
    } else {
      this.showToast(message, "error")
    }
  }

  getSuppliers = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.getSuppliers(this.props.selectedHotelId.id))
    if (status == "success") {
      this.setState({ suppliers: data })
      return data
    } else {
      this.showToast(message, "error")
      return []
    }
  }

  onDelete = async (item) => {
    const { status, message, data } = await API(this, "post", URL_PATH.deleteMenu(item.id))
    if (status == "success") {
      this.showToast(message, "success")
    } else {
      this.showToast(message, "error")
    }
  }

  rawInputChange = (e, index, index2) => {
    const { rawMaterial } = this.state
    rawMaterial[index][index2] = e.target.value

    switch (index2) {
      case 1:
      case 3:
        if (rawMaterial[index][1] && rawMaterial[index][3])
          rawMaterial[index][4] = Number.parseFloat(rawMaterial[index][1]) * Number.parseFloat(rawMaterial[index][3])
        else rawMaterial[index][4] = ""
        break
      case 5:
        if (rawMaterial[index][4] && rawMaterial[index][5])
          rawMaterial[index][6] =
            Number.parseFloat(rawMaterial[index][4]) +
            Number.parseFloat(rawMaterial[index][4]) * (Number.parseFloat(rawMaterial[index][5]) / 100)
        else rawMaterial[index][6] = ""
    }

    this.setState({
      rawMaterial,
    })
  }

  renderRawInput = (value, index, index2) => {
    const units = ["Select Unit", "kg", "gm", "ltr", "ml", "pcs", "dozen", "box", "bag", "bottle", "carton", "roll"]

    if (index2 == 2) {
      return (
        <Select fullWidth value={value} onChange={(e) => this.rawInputChange(e, index, index2)}>
          {units.map((unit, idx) => (
            <MenuItem key={idx} value={unit}>
              {unit}
            </MenuItem>
          ))}
        </Select>
      )
    }

    return (
      <TextField
        fullWidth
        type={index2 == 0 ? "text" : "number"}
        value={value}
        onChange={(e) => this.rawInputChange(e, index, index2)}
        disabled={index2 == 4 || index2 == 6}
        InputLabelProps={{ shrink: true }}
      />
    )
  }

  addRawRow = (n) => {
    const { rawMaterial } = this.state
    for (let index = 0; index < n; index++) {
      rawMaterial.push(["", "", "", "", "", "", ""])
    }
    this.setState({
      rawMaterial,
    })
  }

  deleteRawRow = (index) => {
    const { rawMaterial } = this.state
    rawMaterial.splice(index, 1)
    this.setState({
      rawMaterial,
    })
  }

  create = async () => {
    const { rawMaterial } = this.state
    for (let index = 0; index < rawMaterial.length; index++) {
      const element = rawMaterial[index]
      for (let index2 = 0; index2 < element.length; index2++) {
        if (index2 == 4 || index2 == 6) continue
        const element2 = element[index2]
        if (element2 == "") {
          this.setState({
            showErrorModal: true,
            modalMessage: "Please fill all the fields correctly",
          })
          return
        }
      }
    }

    const formData = new FormData(document.getElementById("hotelForm"))
    formData.append("items", JSON.stringify(rawMaterial))
    const { status, message, data } = await API(this, "post", URL_PATH.createInventoryInvoice, formData)
    if (status == "success") {
      this.showToast(message, "success")
    } else {
      this.showToast(message, "error")
    }
  }

  handleSuccessModalClose = () => {
    this.setState({ showSuccessModal: false })
    this.props.history.push(routes.admin.invoices.list)
  }

  handleErrorModalClose = () => {
    this.setState({ showErrorModal: false })
  }

  render() {
    const { currentSupplier, currentInvoiceFile } = this.state

    return (
      <Container maxWidth="lg">
        <Box sx={{ my: 4 }}>
          <Header title="Update Purchase Invoice"/>
          
    
        </Box>

        <Card sx={{ mb: 3, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
          <CardHeader title="Invoice Details" />
          <CardContent>
            <form
              id="hotelForm"
              onSubmit={(e) => {
                e.preventDefault()
                this.create()
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Supplier"
                    id="supplier"
                    name="inventory_supplier_id"
                    select
                    required
                    value={this.state.selectedSupplierId}
                    InputLabelProps={{ shrink: true }}
                    helperText={currentSupplier ? `Current: ${currentSupplier.supplier_name}` : ""}
                    onChange={(e) => {
                      this.setState({
                        selectedSupplierId: e.target.value,
                        showOtherSupplier: e.target.value == 0,
                      })
                    }}
                  >
                    <MenuItem value="">Select Supplier</MenuItem>
                    {this.state.suppliers.map((item, index) => (
                      <MenuItem key={index} value={item.id}>
                        {item.supplier_name}
                      </MenuItem>
                    ))}
                    {/* Show current supplier even if it's not in the active suppliers list */}
                    {currentSupplier && !this.state.suppliers.find((s) => s.id === currentSupplier.id) && (
                      <MenuItem value={currentSupplier.id || 0}>{currentSupplier.supplier_name} (Deleted)</MenuItem>
                    )}
                    <MenuItem value="0">New</MenuItem>
                  </TextField>
                </Grid>
                {this.state.showOtherSupplier && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Other Supplier"
                      id="other_supplier"
                      name="other_supplier"
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Invoice Number"
                    id="invoice_number"
                    name="invoice_number"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <style>
                    {`
          input[type="date"]::-webkit-calendar-picker-indicator {
            filter: invert(1);
            margin-left: 8px;
          }
          input[type="date"] {
            padding-right: 8px;
          }
        `}
                  </style>
                  <TextField
                    fullWidth
                    label="Invoice Date"
                    id="invoice_date"
                    name="invoice_date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Invoice Amount"
                    id="invoice_amount"
                    name="invoice_amount"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Delivery Charge"
                    id="delivery_charge"
                    name="delivery_charge"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="GST Amount"
                    id="gst_amount"
                    name="gst"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Upload Invoice File"
                    id="invoice_file"
                    name="invoice_file"
                    type="file"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                  {/* Display current invoice file preview */}
                  {currentInvoiceFile && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2,marginTop:"8px" }}>
                        <img
                          src={currentInvoiceFile || "/placeholder.svg"}
                          alt="Invoice preview"
                          style={{
                            maxWidth: "200px",
                            maxHeight: "150px",
                            objectFit: "contain",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                          onError={(e) => {
                            // If image fails to load, show a document icon or placeholder
                            e.target.style.display = "none"
                            e.target.nextSibling.style.display = "block"
                          }}
                        />
                        <Box sx={{ display: "none" }}>
                          <Typography variant="body2" sx={{ color: "#FFC857" }}>
                            📄 Document file
                          </Typography>
                        </Box>
                        {/* <Button
                          component="a"
                          href={currentInvoiceFile}
                          target="_blank"
                          rel="noopener noreferrer"
                          variant="outlined"
                          size="small"
                          sx={{
                            color: "#FFC857",
                            borderColor: "#FFC857",
                            "&:hover": {
                              borderColor: "#E6B74D",
                              backgroundColor: "rgba(255, 200, 87, 0.1)",
                            },
                          }}
                        >
                          View Full Size
                        </Button> */}
                      </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Payment Status"
                    id="payment_status"
                    name="payment_status"
                    select
                    required
                    value={this.state.selectedPaymentStatus}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => {
                      this.setState({
                        selectedPaymentStatus: e.target.value,
                      })
                    }}
                  >
                    <MenuItem value="1">Paid</MenuItem>
                    <MenuItem value="2">Unpaid</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>

        <Card sx={{ mb: 3, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
          <CardHeader title="Raw Material Details" />
          <CardContent>
            <TableContainer component={Paper}>
              <Table sx={{ backgroundColor: "#02111B", backgroundImage: "none" }}>
                <TableHead>
                  <TableRow>
                    {["Name", "Quantity", "Unit", "Price", "Total", "GST(%)", "Total with GST", "Action"].map(
                      (item, index) => (
                        <TableCell key={index}>{item}</TableCell>
                      ),
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.rawMaterial.map((item, index) => (
                    <TableRow key={index}>
                      {item.map((value, index2) => (
                        <TableCell key={index2}>{this.renderRawInput(value, index, index2)}</TableCell>
                      ))}
                      <TableCell>
                        <IconButton onClick={() => this.deleteRawRow(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
              <Box>
                <Button
                  variant="contained"
                  onClick={() => this.addRawRow(1)}
                  sx={{ mr: 1, backgroundColor: "#FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#E6B74D" } }}
                >
                  + Add Row
                </Button>
                <Button
                  variant="contained"
                  onClick={() => this.addRawRow(5)}
                  sx={{ mr: 1, backgroundColor: "#FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#E6B74D" } }}
                >
                  + Add 5 Rows
                </Button>
                <Button
                  variant="contained"
                  onClick={() => this.addRawRow(10)}
                  sx={{ mr: 1, backgroundColor: "#FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#E6B74D" } }}
                >
                  + Add 10 Rows
                </Button>
              </Box>
              <Button
                variant="contained"
                type="submit"
                onClick={() => this.create()}
                sx={{ mr: 1, backgroundColor: "#FFC857", fontWeight: 700, "&:hover": { backgroundColor: "#E6B74D" } }}
              >
                Save Changes
              </Button>
            </Box>
          </CardContent>
        </Card>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Container>
    )
  }
}

export default redux(ListMenuScreen)
